/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AdminTenantSettingKey = {
    COURSES_ENABLED: 'COURSES_ENABLED',
    SUBORGANISATION_ENABLED: 'SUBORGANISATION_ENABLED'
} as const;
export type AdminTenantSettingKey = typeof AdminTenantSettingKey[keyof typeof AdminTenantSettingKey];

